


























































import { Component, Mixins } from "vue-property-decorator";
import ProfilesMixin from "@/mixins/http/Profile";
import { Profile } from "@/models";

const REQUEST_TAG = "profiles";

@Component({
  components: {},
})
export default class AdminProfileList extends Mixins(ProfilesMixin) {
  profiles: Profile[] = [];
  loading = false;

  created() {
    this.load();
  }

  async load() {
    this.loading = true;
    this.profiles = await this.getProfiles(REQUEST_TAG);
    this.loading = false;
  }
}
